import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { buildMotorDataDrawerMultiAxisItems } from '../../../../utils/electronicsDashboardUtils';
import DraggableComponent from '../../DraggableComponent';
import { DrawerSectionStack, type MotorDrawerSectionProps } from '../DrawerDraggableLayout';

const MotorAdvancedDrawerSection = ({ motorPorts, projectCode }: MotorDrawerSectionProps) => {
  const { t } = useTranslation();

  const multiAxisItems = useMemo(() => buildMotorDataDrawerMultiAxisItems(motorPorts, projectCode), [motorPorts, projectCode]);

  if (multiAxisItems.length === 0) {
    return null;
  }

  return (
    <DrawerSectionStack>
      {multiAxisItems.map(({ key, port, widget, titleI18nKey, titleDefault }) => (
        <DraggableComponent
          key={key}
          id={widget.id}
          type={widget.type}
          dataKey={widget.dataKey}
          minH={widget.minH}
          minW={widget.minW}
          options={widget.options}
          title={t(titleI18nKey, { port, defaultValue: titleDefault })}
          sx={{ m: 0 }}
        />
      ))}
    </DrawerSectionStack>
  );
};

export default MotorAdvancedDrawerSection;
